/*
 * 6a temizliği: sıcak yüzey, krom ve denetim kenarlığı satırları emekli oldu;
 * okuyan modüller tasarım adlarına geçti (`band`, `text-on-band`,
 * `text-on-band-secondary`, `border-strong`). Kalan satırlar kalıcıdır.
 */
export const LEGACY_COLOR_KEYS = {
    qrSurface: {
        kaynak: { tasarim: 'background', tema: 'light' },
        emekli: 'kalici',
        gerekce: 'QR sessiz bölgesi iki temada açık kalır, optik okuyucu koyu modül ve açık zemin bekler.',
    },
    qrModule: {
        kaynak: { tasarim: 'textPrimary', tema: 'light' },
        emekli: 'kalici',
        gerekce: 'QR modülü iki temada koyu mürekkep, açık temanın textPrimary değeri.',
    },
    fixedWhite: {
        kaynak: { tasarim: 'background', tema: 'light' },
        emekli: 'kalici',
        gerekce: 'Temadan bağımsız beyaz (README Renk: kamera çerçevesi ve baskı yüzeyi beyazı, anahtar topuzu, yüz halkası). Renk ailesi L20 ile textOnBand mürekkebe döndü; iki temada beyaz kalan tasarım adı yok.',
    },
    fixedPrimary: {
        kaynak: { tasarim: 'primary', tema: 'light' },
        emekli: 'kalici',
        gerekce: 'Temadan bağımsız koyu mor: logosu ve rengi olmayan kurumun harf rozeti (`OrgMark` `ink` hâli) web ve PDF yüzeylerinin hepsinde #3A13AE zemin, beyaz harf, iki temada aynı (kullanıcı kararı 30.10.2026; kaynak PanelKapi `.wb-gate__top .wb-orglogo`). Koyu temanın primary değeri bantla aynı lavantadır ve monogram bantta kaybolurdu. Env markası verilirse açık temanın türetilmiş tonunu taşır.',
    },
    fixedInk: {
        kaynak: { tasarim: 'textOnBand' },
        emekli: 'kalici',
        gerekce: 'Temadan bağımsız mürekkep #16171A (README Renk: telefon çerçevesi, e-posta ve bildirim önizlemesi gibi baskı yüzeyleri). Değeri iki temada aynı olan textOnBand adından gelir; bant dışında textOnBand okunmaz.',
    },
};
/*
 * 6a temizliği: eski gölge (`--ib-elevation-*`) ve boşluk (`--ib-space-xs` …)
 * adları emekli oldu, okuyan modüller `--ib-shadow-*` ve `--ib-space-<n>`
 * adlarına geçti (değerler birebir aynıydı). Köşede `sm` → `radius-tag`,
 * `xl` → `radius-card` oldu.
 */
/**
 * Eski köşe adlarından kalan iki satır. `md` (8) ve `lg` (12) tasarım ölçeğinde
 * YOKTUR (`webRadius`: 4, 6, 10, 16 …); okuyan modülü yeni ada geçirmek köşeyi
 * değiştirir. 6a görsel değişiklik yapmadığı için satırlar kalır, eşleme
 * tasarım kararını bekler (`karar`).
 */
export const LEGACY_RADIUS = {
    md: { kaynak: { sabit: 8 }, emekli: 'karar' },
    lg: { kaynak: { sabit: 12 }, emekli: 'karar' },
};
//# sourceMappingURL=eski-anahtarlar.js.map